module.exports = __webpack_public_path__ + "prod/1.42.2/img/bannerForm.1adc32a7.png";